export default __webpack_public_path__ + "static/media/footer3.22f92540.svg";